import * as React from "react";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import styles from "src/components/UI/LeftCard/assets/scss/Menu.module.scss";
import { _GetTitle, _GetType } from "src/components/UI/Shared/handler";
import {
  FreeIcon,
  PremiumIcon,
  MixedIcon,
} from "src/components/UI/LeftCard/icons";
import path from "src/config/search.json";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

interface ControlledOpenSelect3Props {}
const keys = Object.keys(path.services);
const currentkey = keys[2];
const ControlledOpenSelect3 = ({}: ControlledOpenSelect3Props) => {
  const dispatch = useDispatch();
  const searchString = useSelector((state: any) => state.app.searchString);
  let navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(
      appActions.setSearchString({
        ...searchString,
        menu3: event.target.value,
      })
    );
  };

  const handleGoToSearchString = (choosen: string) => {
    if (choosen === "generate-points") {
      dispatch(appActions.setActivePanel("generator"));
      navigate(`${currentkey}/${path.services.Data_Generator[0].url}`);
    } else if (choosen === "generate-lines") {
      dispatch(appActions.setActivePanel("generator"));
      navigate(`${currentkey}/${path.services.Data_Generator[1].url}`);
    } else if (choosen === "generate-polygons") {
      dispatch(appActions.setActivePanel("generator"));
      navigate(`${currentkey}/${path.services.Data_Generator[2].url}`);
    } else if (choosen === "picker") {
      navigate(`${currentkey}/${path.services.Data_Generator[3].url}`);
    } else if (choosen === "export") {
      navigate(`${currentkey}/${path.services.Data_Generator[4].url}`);
    }
  };
  React.useEffect(() => {
    handleGoToSearchString(searchString.menu3);
  }, [searchString]);
  const Icon = (category: number, item: number) => {
    const type = _GetType(category, item);
    if (type === "free") return <FreeIcon />;
    else if (type === "premium") return <PremiumIcon />;
    return <MixedIcon />;
  };
  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 120, margin: "0.75rem 0" }}>
        <InputLabel
          id="demo-controlled-open-select-label"
          className={styles.label}
        >
          Data Generator{" "}
        </InputLabel>
        <Select
          className={styles.select}
          labelId="demo-controlled-open-select-label"
          id="demo-controlled-open-select"
          open={open}
          value={searchString.menu3}
          onChange={handleChange}
          onClose={handleClose}
          onOpen={handleOpen}
          label="selectValue"
        >
          <MenuItem className={styles.menuItem} value={"generate-points"}>
            {_GetTitle(2, 0)}
            {Icon(2, 0)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"generate-lines"}>
            {_GetTitle(2, 1)}
            {Icon(2, 1)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"generate-polygons"}>
            {_GetTitle(2, 2)}
            {Icon(2, 2)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"picker"}>
            {_GetTitle(2, 3)}
            {Icon(2, 3)}
          </MenuItem>
          <MenuItem className={styles.menuItem} value={"export"}>
            {_GetTitle(2, 4)}
            {Icon(2, 4)}
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

export default ControlledOpenSelect3;
